class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.cartDrawer = document.querySelector('cart-drawer');
    this.addEventListener('click', this.onClick.bind(this));
  }

  connectedCallback() {
    this.performRecommendations();
  }

  performRecommendations() {
    const recommendations = this.querySelector(
      '[data-recommendations]'
    );
    if (!recommendations) return;
    // Try curated complementary products first; fall back to related so the upsell
    // always shows something even when no complementary products are configured.
    this.fetchInto(recommendations, this.dataset.url, this.dataset.urlFallback);
  }

  fetchInto(target, url, fallbackUrl) {
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-recommendations]')?.innerHTML?.trim();
        if (!html) {
          if (fallbackUrl) this.fetchInto(target, fallbackUrl, null);
          return;
        }
        this.classList.remove('hidden');
        target.innerHTML = html;
        this.initSlider();
      });
  }

  initSlider() {
    this.slider = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 1,
      spaceBetween: 12
    });
  }

  onClick(event) {
    const addButton = event.target.closest('[data-upsell-add]');
    if (!addButton) return;
    event.preventDefault();
    this.addUpsell(addButton);
  }

  addUpsell(addButton) {
    const item = addButton.closest('[data-upsell-item]');
    const select = item ? item.querySelector('[data-upsell-variant]') : null;
    const variantId = (select && select.value) || addButton.dataset.defaultVariant;
    if (!variantId) return;

    addButton.classList.add('disabled');

    const cartDrawer = this.cartDrawer || document.querySelector('cart-drawer');
    const sections = cartDrawer
      ? cartDrawer.getSectionsToRender().map(section => section.section)
      : [];

    const body = JSON.stringify({
      id: variantId,
      quantity: 1,
      sections,
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          console.error(response.description);
          return;
        }
        if (cartDrawer) cartDrawer.renderContents(response);
      })
      .catch(error => console.error(error))
      .finally(() => addButton.classList.remove('disabled'));
  }
}

customElements.define('cart-recommendations', CartRecommendations);
